const zh = {
	// 账户余额
	accountBalance: {
		title: '账户余额',
		account: '账户',
		withdraw: '提现',
		balance: '账户余额',
		frozenBalance: '冻结金额',
		RollingReserveBalance: '循环保证金金额',
		fixedReserveBalance: '固定保证金金额',
		availableBalance: '可提现金额',
		availableBalance2: '实际可提现总金额',
		accountDetail: '账户明细',
		group: '群组',
		storeName: '群组/网站',
		storeName1: '网站',
		businessType: '业务类型',
		revenueExpense: '收入/支出',
		revenue: '收入',
		expense: '支出',
		transactionId: '原交易订单号',
		orderId: '网站订单号',
		time: '结算时间',
		search: '查询',
		clear: '重置',
		exportExcel: '导出',
		balanceAccount: '账户明细',
		frozenAccount: '冻结账户',
		RollingReserveAccount: '循环保证金账户',
		fixedReserveAccount: '固定保证金账户',
		amount: '总金额',
		hideDetail: '隐藏详情',
		showDetail: '显示详情'
	},

	filter: {
		webSite: '网站',
		all: '全部',
		status: '状态',
		groupName: '群组',
		date: '时间',
		selectDate: '选择日期',
		remitted: '打款成功',
		remitting: '打款中',
		failed: '打款失败',
		_return: '退票',
		quicklySelect: {
			lab: '快速选择',
			range: {
				today: '今天',
				lastWeek: '最近一周',
				lastMonth: '最近一个月',
				lastYear: '最近一年'
			}
		}
	},
	tableColumns: {
		withdrawalTime: '提现时间',
		withdrawalFlowID: '提现流水号',
		webSite: '网站',
		groupName: '群组',
		paymentAccount: '打款账户',
		withdrawalAmount: '提现金额',
		withdrawalFee: '提现手续费',
		transferredAmount: '到账金额',
		remittanceTime: '打款时间',
		status: '状态',
		orderStatus: '订单状态',
		riskDetail: '详情',
		noData: '暂无数据',
		exportFaild: '导出信息失败，请联稍后再试',
		operator: '操作员',
		riskFieldTips: '经评估本次可提现金额为 {0} {1}，请重新发起。',
		receiptBtn: '下载凭证'
	},
	unsettled: {
		currency: '交易币种',
		totalAmount: '交易汇总金额（折合美金计算）为',
		title: '待结算交易统计',
		view: '视图',
		amount: '总金额',
	 	storeName: '网站/群组',
	    omniStoreName: '门店/网站/群组',
		orderId: '网站订单号',
		flowId: '交易流水号',
		usdAmount: '折合美金金额',
		transRecord: '待结算明细查询',
		time: '交易时间',
		tip: '* 此页面所有金额均为待结算交易金额，最终以实际结算金额为准',
		more: '展开',
		collapse: '收起',
		totalAmountUSD: '总金额(USD)'

	},
	withdrawalDetail: {
		title: '提现明细',
		dialogTitle: '提现详情',
		groupName: '包含出金群组',
		withdrawalFlowID: '提现流水号',
		search: '搜索',
		reset: '重置筛选'
	}
}

export default zh
